export default __webpack_public_path__ + "static/media/gamerscorner.be2cb82a.png";